import { GanttBaseCellError } from "elements/gantt/types";
import { KonvaTooltip } from "frontend/ui-components/design-system/tooltip/konva-tooltip";
import React, { useRef } from "react";
import { Group, Path, Rect, Text } from "react-konva";
import Konva from "konva";

const LoadingErrorIcon = ({ x = 0, y = 0 }: { x?: number; y?: number }) => {
  return (
    <Path
      x={x}
      y={y}
      listening={false}
      stroke="#1E1E1E"
      strokeWidth={1}
      width={18}
      height={18}
      data={`
      M10 0.5
      A9.5 9.5 0 1 1 0.5 10
      A9.5 9.5 0 0 1 10 0.5
      M6.21436 9.97656
      L13.7858 9.97656
    `}
      lineCap="round"
    />
  );
};

const errorToCTA: Record<
  GanttBaseCellError,
  { icon: React.ComponentType<{ x?: number; y?: number }>; message: string; action: "retry" | "close" }
> = {
  "failed-loading": { icon: LoadingErrorIcon, message: "Unable to load item", action: "retry" },
};

export const TaskErrorState = ({
  open,
  layout,
  errorType,
  _onAction,
}: {
  layout: "small" | "large";
  errorType: GanttBaseCellError;
  open: boolean;
  _onAction: (action: "retry" | "close") => void;
}) => {
  const IconComponent = errorToCTA[errorType].icon;
  const message = errorToCTA[errorType].message;
  // const action = errorToCTA[errorType].action;
  const tooltipRef = useRef<Konva.Rect>(null);

  return (
    <Group>
      {layout === "large" ? (
        <>
          {/* <Rect
            x={10}
            y={5}
            width={200}
            height={60}
            cornerRadius={6}
            ref={tooltipRef}
            fill="red"
            stroke="transparent"
          /> */}
          <IconComponent x={20} y={25} />

          <Text
            x={50}
            y={30}
            width={600}
            text={message}
            fontFamily={"Poppins"}
            fill={"#1E1E1E"}
            fontSize={12}
            ellipsis={true}
            height={30}
            align="left"
          />
          {/* <Text
            x={50}
            y={40}
            width={100}
            text={"Retry"}
            fontFamily={"Poppins"}
            fill={"#1973FF"}
            fontSize={12}
            ellipsis={true}
            onMouseEnter={(e) => {
              setMousePointer(e);
            }}
            onMouseLeave={(e) => {
              unsetMouse(e);
            }}
            onClick={(e) => {
              e.cancelBubble = true;
              onAction(action);
            }}
          /> */}
        </>
      ) : (
        <Group x={40} y={22}>
          <Rect
            x={-5}
            y={-5}
            width={30}
            height={30}
            cornerRadius={6}
            ref={tooltipRef}
            fill="transparent"
            stroke="transparent"
          />
          <IconComponent />
          <KonvaTooltip
            text={
              <div style={{ display: "flex", flexDirection: "column", gap: 4, alignItems: "center" }}>
                <div style={{ fontSize: 12, fontFamily: "Poppins", fontWeight: 400, color: "#fff" }}>{message}</div>
                {/* <button
                  style={{
                    color: "#5195FF",
                    fontFamily: "Poppins",
                    fontSize: "12px",
                    fontWeight: 400,
                    background: "transparent",
                    border: "none",
                    cursor: "pointer",
                  }}
                  onClick={() => {
                    onAction(action);
                  }}
                >
                  {action === "retry" ? "Retry" : "Close"}
                </button> */}
              </div>
            }
            nodeRef={tooltipRef}
            side="top"
            open={open}
            maxWidth={330}
          />
        </Group>
      )}
    </Group>
  );
};
